/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ current: NonNullable<unknown>, total: NonNullable<unknown> }} Sync_Changes_Status_ProgressInputs */

const en_sync_changes_status_progress = /** @type {(inputs: Sync_Changes_Status_ProgressInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Syncing event ${i?.current}/${i?.total}`)
};

const fr_sync_changes_status_progress = /** @type {(inputs: Sync_Changes_Status_ProgressInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Synchronisation de l'evenement ${i?.current}/${i?.total}`)
};

const de_sync_changes_status_progress = /** @type {(inputs: Sync_Changes_Status_ProgressInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Synchronisierungsereignis ${i?.current}/${i?.total}`)
};

const it_sync_changes_status_progress = /** @type {(inputs: Sync_Changes_Status_ProgressInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Sincronizzazione evento ${i?.current}/${i?.total}`)
};

const ru_sync_changes_status_progress = /** @type {(inputs: Sync_Changes_Status_ProgressInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Синхронизация события ${i?.current}/${i?.total}`)
};

const es_sync_changes_status_progress = /** @type {(inputs: Sync_Changes_Status_ProgressInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Evento de sincronización ${i?.current}/${i?.total}`)
};

const zh_cn2_sync_changes_status_progress = /** @type {(inputs: Sync_Changes_Status_ProgressInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`同步事件 ${i?.current}/${i?.total}`)
};

const ja_sync_changes_status_progress = /** @type {(inputs: Sync_Changes_Status_ProgressInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`イベント ${i?.current}/${i?.total} を同期しています`)
};

const hi_sync_changes_status_progress = /** @type {(inputs: Sync_Changes_Status_ProgressInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`सिंक्रोनाइज़िंग इवेंट ${i?.current}/${i?.total}`)
};

const pt_pt2_sync_changes_status_progress = /** @type {(inputs: Sync_Changes_Status_ProgressInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Sincronizando evento ${i?.current}/${i?.total}`)
};

/**
* | output |
* | --- |
* | "Syncing event {current}/{total}" |
*
* @param {Sync_Changes_Status_ProgressInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const sync_changes_status_progress = /** @type {((inputs: Sync_Changes_Status_ProgressInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Sync_Changes_Status_ProgressInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_sync_changes_status_progress(inputs)
	if (locale === "de") return de_sync_changes_status_progress(inputs)
	if (locale === "it") return it_sync_changes_status_progress(inputs)
	if (locale === "ru") return ru_sync_changes_status_progress(inputs)
	if (locale === "es") return es_sync_changes_status_progress(inputs)
	if (locale === "zh-CN") return zh_cn2_sync_changes_status_progress(inputs)
	if (locale === "ja") return ja_sync_changes_status_progress(inputs)
	if (locale === "hi") return hi_sync_changes_status_progress(inputs)
	if (locale === "pt-PT") return pt_pt2_sync_changes_status_progress(inputs)
	return en_sync_changes_status_progress(inputs)
});